<div class="main-container" [ngClass]="{ loading: loading }">
  <app-loading-spinner
    class="loading-spinner"
    [loading]="loading"
  ></app-loading-spinner>

  <div class="container min-container mx-auto py-4 py-lg-5">
    <div class="row mb-4">
      <div
        class="col-12 py-4 image-container"
        [style.backgroundImage]="'url(' + site.image.source + ')'"
        >
        <div class="row w-100 h-100 m-0 py-5">
          <h3 class="col-12">{{ site.image.title }}</h3>

          <h5 class="my-5 col-12 my-auto font-regular">
            {{
            isLogged ? site.image.subtitle : "¡Hemos recibido su solicitud!"
            }}
          </h5>
        </div>
      </div>
    </div>

    @if (!isRegister) {
      <div class="row">
        @if (site.subtitle || site.messages.length > 0) {
          <div
            class="col-12 text-center mt-4"
            >
            @if (site.subtitle) {
              <h3 class="mb-4">{{ site.subtitle }}</h3>
            }
            @for (msg of site.messages; track msg) {
              <p class="mb-0">
                <span>{{ msg }}</span> <br />
              </p>
            }
          </div>
        }
        @if (site.subtitleAction.link && site.subtitleAction.text) {
          <div
            class="col-12 text-center mt-3"
            >
            @if (
              type === 'congress' ||
              type === 'default' ||
              type === 'somos' ||
              type === 'ammom') {
              <a
                class="amm-link"
                [href]="site.subtitleAction.link"
                target="_blank"
                rel="noopener noreferrer"
                >
                {{ site.subtitleAction.text }}
              </a>
            } @else {
              <a class="amm-link" [routerLink]="site.subtitleAction.link">
                {{ site.subtitleAction.text }}
              </a>
            }
          </div>
        }
      </div>
    } @else {
      <app-finish-register [profile]="profile"></app-finish-register>
    }


    <div class="row">
      <hr class="col-12 my-5" />

      <h3 class="col-12 text-center">Accesos rápidos</h3>
    </div>

    <div class="row py-4 justify-content-evenly">
      @for (shortcut of shortcuts; track shortcut; let ind = $index) {
        <div
          class="col-5 col-md-4 col-lg-3 text-center mb-3 mb-md-0"
          [ngClass]="{ 'px-0': shortcuts.length < 4 }"
          >
          <a
            class="shortcut-card text-center m-auto text-decoration-none"
            [ngClass]="ind === 0 ? 'shortcut-' + type + '-active' : ''"
            [routerLink]="'/' + shortcut.link"
            >
            <img
              [src]="'icons/' + shortcut.image | siteAsset : siteEnum"
              alt=""
              />
            <span class="lh-sm" [innerHTML]="shortcut.name"></span>
          </a>
        </div>
      }
    </div>
  </div>
</div>
